import { render } from "./TCMathGamesList.vue?vue&type=template&id=f67abbae&scoped=true"
import script from "./TCMathGamesList.vue?vue&type=script&lang=js"
export * from "./TCMathGamesList.vue?vue&type=script&lang=js"

import "./TCMathGamesList.vue?vue&type=style&index=0&id=f67abbae&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tunescrib-rs/tunescrib-rs/dev.tunescrib.com-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f67abbae"]])

export default __exports__